import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardHeader,
  Divider,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import { useTranslation } from "react-i18next"; // Functional Components
import YearReport from "../../components/report/YearReport";
import MonthReport from "../../components/report/MonthReport";
import DateReport from "../../components/report/DateReport";

export default function ReportList() {
  const { t } = useTranslation();
  const [type, setType] = useState("amount");

  const handleChange = (event, newValue) => {
    setType(newValue);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Box sx={{ mb: 1 }}>
        <ToggleButtonGroup
          color="primary"
          fullWidth
          value={type}
          exclusive
          onChange={handleChange}
        >
          <ToggleButton value="amount">
            {t("dashboard.order_total")}
          </ToggleButton>
          <ToggleButton value="count">
            {t("dashboard.order_count")}
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <DateReport type={type} />
        </Grid>
        <Grid item xs={12} md={6}>
          <MonthReport type={type} />
        </Grid>
        <Grid item xs={12} md={6}>
          <YearReport type={type} />
        </Grid>
      </Grid>
    </Box>
  );
}
